import React from "react";

const PAN_CARD_ACCEPT = ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png";

function fieldClass(message) {
  return `form-control${message ? " is-invalid" : ""}`;
}

function Field({ label, required, error, className = "col-12", hint, children }) {
  return (
    <div className={className}>
      <label className="form-label">
        {label}
        {required ? <span className="text-danger-600"> *</span> : null}
      </label>
      {children}
      {hint && !error ? <small className="text-secondary text-xs d-block mt-1">{hint}</small> : null}
      {error ? <small className="text-danger-600 text-xs d-block mt-1">{error}</small> : null}
    </div>
  );
}

export default function CustomerFormFields({
  form,
  errors = {},
  disabled = false,
  onChange,
  variant = "stacked",
  autoFocus = false,
  fileInputKey,
  onViewPanCard,
}) {
  function update(field, value) {
    if (onChange) onChange({ ...form, [field]: value });
  }

  const colClass = variant === "split" ? "col-12 col-md-6" : "col-12";
  const selectedFileName = form.pan_card?.name || "";
  const existingFileName = form.pan_card_file_name || "";
  const showExistingFile = Boolean(form.has_pan_card && existingFileName && !form.pan_card);

  return (
    <div className="row g-3">
      <Field label="First Name" required error={errors.cust_name} className={colClass}>
        <input
          className={fieldClass(errors.cust_name)}
          value={form.cust_name}
          disabled={disabled}
          autoComplete="given-name"
          autoFocus={autoFocus}
          onChange={(event) => update("cust_name", event.target.value)}
        />
      </Field>
      <Field label="Last Name" required error={errors.cust_last_name} className={colClass}>
        <input
          className={fieldClass(errors.cust_last_name)}
          value={form.cust_last_name}
          disabled={disabled}
          autoComplete="family-name"
          onChange={(event) => update("cust_last_name", event.target.value)}
        />
      </Field>
      <Field label="Email" required error={errors.cust_email} className={colClass}>
        <input
          type="email"
          className={fieldClass(errors.cust_email)}
          value={form.cust_email}
          disabled={disabled}
          autoComplete="email"
          onChange={(event) => update("cust_email", event.target.value)}
        />
      </Field>
      <Field label="Mobile" required error={errors.cust_mobile} className={colClass}>
        <input
          type="tel"
          className={fieldClass(errors.cust_mobile)}
          value={form.cust_mobile}
          disabled={disabled}
          autoComplete="tel"
          onChange={(event) => update("cust_mobile", event.target.value)}
        />
      </Field>
      <Field label="Customer PAN No" error={errors.cust_pan} className={colClass}>
        <input
          className={fieldClass(errors.cust_pan)}
          value={form.cust_pan}
          disabled={disabled}
          maxLength={10}
          autoComplete="off"
          placeholder="ABCDE1234F"
          onChange={(event) => update("cust_pan", event.target.value.toUpperCase())}
        />
      </Field>
      <Field
        label="Upload PAN Card Photo"
        error={errors.pan_card}
        className={colClass}
        hint={selectedFileName || showExistingFile ? undefined : "Optional. PDF, JPG, or PNG up to 10 MB"}
      >
        <input
          key={fileInputKey || "pan-card"}
          type="file"
          accept={PAN_CARD_ACCEPT}
          className={fieldClass(errors.pan_card)}
          disabled={disabled}
          onChange={(event) => update("pan_card", event.target.files?.[0] || null)}
        />
        {selectedFileName ? (
          <small className="text-secondary text-xs d-block mt-1">Selected: {selectedFileName}</small>
        ) : null}
        {showExistingFile ? (
          <div className="d-flex align-items-center gap-2 mt-1">
            <small className="text-secondary text-xs">Current file: {existingFileName}</small>
            {typeof onViewPanCard === "function" ? (
              <button type="button" className="btn btn-link p-0 text-xs" disabled={disabled} onClick={onViewPanCard}>
                View
              </button>
            ) : null}
          </div>
        ) : null}
      </Field>
    </div>
  );
}
